<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>APP管理</BreadcrumbItem>
        <BreadcrumbItem>主页应用</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.name" placeholder="标题" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>新增应用</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'newslist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['dic/getId', 'dic/save', 'dic/delete'],
        [
          {
            type: 'input',
            title: '应用名称',
            name: 'name',
            model: '',
            block: true,
          },
          {
            type: 'input',
            title: '超链接',
            name: 'url',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            title: '排序',
            name: 'sort',
            model: 1,
            block: true,
          },
          {
            type: 'uploadimg',
            title: '应用图标',
            name: 'icon',
            pictype: {
              type: 'gallery',
              size: '200*200'
            },
            model: '',
            block: true,
          },
          {
            type: 'textarea',
            title: '备注',
            name: 'remark',
            model: ''
          },
          {
            type: 'radio',
            title: '身份认证',
            name: 'lv',
            model: 'LV0',
            children: [
              { title: 'LV0' },
              { title: 'LV1' },
              { title: 'LV2' }
            ]
          },

          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }, {
              name: 'rootid',
              model: 'application'
            }]
          }
        ]
      ],
      queryData: ['dic/getQueryList?rootid=application',
        [
          {
            title: '应用图标',
            key: '',
            render: (h, params) => {

              return h('viewer', [
                h('img', {
                  style: {//设置样式
                    display: 'inline-block',
                    width: '40px',
                    height: '47px',
                    position: 'relative',
                    top: '4px'
                  },
                  attrs: {//设置属性
                    src: params.row.icon
                  }
                })]
              )
            }

          },
          {
            title: '应用名称',
            key: 'name',
            render: (h, params) => {
              return h('span', decodeURI(params.row.name))
            }
          },
          {
            title: '排序',
            key: 'sort',
            width: 150,
            align: 'center',
          },
          {
            title: '链接地址',
            key: 'url',
          },

          {
            title: '操作',
            slot: 'action',
            width: 100,
            align: 'center',
            // render: (h, params) => {
            //   return h('div', [
            //     h('span', {
            //       style: {
            //         display: 'inline-block',
            //         width: '60px',
            //         height: '25px',
            //         background: '#2db7f5',
            //         borderRadius: '6px',
            //         textAlign: 'center',
            //         lineHeight: '25px',
            //         color: '#fff',
            //         fontSize: '12px',
            //         cursor: 'pointer',
            //         userSelect: 'none'
            //       },
            //       on: {
            //         click: () => {

            // 		  this.$router.push('/db')



            //         }
            //       }
            //     }, '编辑')
            //   ])

            // }
          }

        ]
      ],
      searchParam: {
        name: '',
        itemid: '',
      },
      issearch: -1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
  },
  methods: {
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, row) {
      console.log(guid, 'guid', this.formData[0][0])

      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      var _guid = guid == -1 ? -1 : row.guid
      this.formData[0][0] = this.formData[0][0] + '?id=' + _guid
      if (guid == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
      this.reloadTmep = Math.random()
    },

    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}
</style>
